import { render } from "./BottomButton.vue?vue&type=template&id=52a228ed&scoped=true&ts=true"
import script from "./BottomButton.vue?vue&type=script&lang=ts"
export * from "./BottomButton.vue?vue&type=script&lang=ts"

import "./BottomButton.vue?vue&type=style&index=0&id=52a228ed&scoped=true&lang=scss"

import exportComponent from "/Users/damiandudek/Desktop/PRACA/git/114.TGA-mobile-git/tga-mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a228ed"]])

export default __exports__